import { render } from "./BrandingLogo.vue?vue&type=template&id=29b71726&scoped=true"
import script from "./BrandingLogo.vue?vue&type=script&lang=js"
export * from "./BrandingLogo.vue?vue&type=script&lang=js"

import "./BrandingLogo.vue?vue&type=style&index=0&id=29b71726&scoped=true&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b71726"]])

export default __exports__